import CustomModuleCards from '../../../components/CustomModuleCard/CustomModuleCards';
import { ViewModule } from '../../../types/api/payload/module';

export default function CompanyFeatures() {
  return <CustomModuleCards view={ViewModule.companyFeature} />;
}
